module.exports = __webpack_public_path__ + "static/media/adobeacrobatreader.241a40b8.svg";